import { render } from "./2016.vue?vue&type=template&id=ab68f8a4"
import script from "./2016.vue?vue&type=script&lang=js"
export * from "./2016.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__